(() => {
  const initialize = () => {
    const root = document.getElementById('monobeach-home');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const popup = root.querySelector('#mb-newsletter-dialog');
    const focusTargets = new WeakMap();
    let timer;
    const storageKey = 'monobeach-newsletter-dismissed-v2';
    const remember = () => { try { localStorage.setItem(storageKey, String(Date.now())); } catch {} };
    const hero = root.querySelector('.mb-hero');
    if (hero) {
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const choices = [...hero.querySelectorAll('[data-hero-index]')];
      const visual = hero.querySelector('.mb-hero-visual');
      let current = 0;
      const selectSlide = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === current)));
        const selected = slides[current];
        hero.querySelector('[data-hero-caption]').textContent = selected.dataset.caption;
        const cta = hero.querySelector('[data-hero-cta]');
        cta.textContent = selected.dataset.cta;
        cta.href = selected.dataset.url;
      };
      hero.addEventListener('click', event => {
        const choice = event.target.closest('[data-hero-index]');
        const arrow = event.target.closest('[data-hero-step]');
        if (choice) selectSlide(Number(choice.dataset.heroIndex));
        if (arrow) selectSlide(current + Number(arrow.dataset.heroStep));
      });
      hero.addEventListener('keydown', event => {
        if (!event.target.closest('.mb-hero-controls')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
        choices[current].focus();
      });
      let swipeStart;
      visual.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button,a')) return;
        swipeStart = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      visual.addEventListener('pointerup', event => {
        if (!swipeStart) return;
        const dx = event.clientX - swipeStart.x;
        const dy = event.clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) selectSlide(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      visual.addEventListener('pointercancel', () => { swipeStart = null; });
    }
    const show = dialog => {
      clearTimeout(timer);
      if (!dialog || dialog.open) return;
      focusTargets.set(dialog, document.activeElement);
      dialog.showModal();
    };
    root.addEventListener('click', event => {
      const trigger = event.target.closest('[data-mb-open]');
      if (trigger) show(root.querySelector('#' + trigger.dataset.mbOpen));
      const close = event.target.closest('[data-mb-close]');
      if (close) close.closest('dialog').close();
      const swatch = event.target.closest('.mb-swatch');
      if (!swatch) return;
      const card = swatch.closest('.mb-product');
      card.querySelectorAll('.mb-swatch').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
      card.querySelectorAll('[data-product-link]').forEach(link => { link.href = swatch.dataset.url; });
      const photo = card.querySelector('.mb-product-scene');
      photo.src = swatch.dataset.scene;
      photo.alt = swatch.dataset.alt;
      card.querySelector('.mb-product-catalog').src = swatch.dataset.image;
      card.querySelector('.mb-product-image').setAttribute('aria-label', swatch.dataset.alt);
      card.querySelector('.mb-price').textContent = swatch.dataset.price;
      card.querySelector('.mb-color-label').textContent = swatch.dataset.color;
    });
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => {
        if (dialog === popup) remember();
        const returnFocus = focusTargets.get(dialog);
        if (returnFocus?.isConnected) returnFocus.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
    });
    if (!popup) return;
    const submitted = popup.querySelector('[data-newsletter-success]');
    const error = popup.querySelector('[data-newsletter-error]');
    if (submitted || error) {
      if (submitted) remember();
      show(popup);
    } else if (root.dataset.popupEnabled === 'true' && root.dataset.customerSubscribed !== 'true') {
      let dismissed = 0;
      try { dismissed = Number(localStorage.getItem(storageKey) || 0); } catch {}
      if (!Number.isFinite(dismissed) || Date.now() - dismissed > 7 * 86400000) {
        const configuredDelay = Number(root.dataset.popupDelay);
        const delay = Number.isFinite(configuredDelay) ? Math.max(0, Math.min(60, configuredDelay)) : 0;
        timer = setTimeout(() => {
          if (!root.isConnected || root.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
          show(popup);
        }, delay * 1000);
      }
    }
    // The standalone preview never pretends to create a Shopify subscriber.
    if (root.dataset.preview === 'true') {
      root.querySelector('.mb-newsletter-form')?.addEventListener('submit', event => {
        event.preventDefault();
        const message = root.querySelector('#mb-preview-message');
        message.hidden = false;
        message.textContent = 'Preview only — your email has not been submitted. The Shopify theme uses the native customer subscription form.';
      });
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
